import * as React from "react";
const SvgSchlieenAlt = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="SchließenAlt">
    <path
      fill="currentColor"
      d="M204.64 51.36a7.5 7.5 0 0 0-10.61 0l-66.04 66.04-66.03-66.04a7.502 7.502 0 1 0-10.61 10.61l66.04 66.04-66.04 66.04a7.502 7.502 0 1 0 10.61 10.61L128 138.62l66.04 66.04a7.502 7.502 0 1 0 10.61-10.61l-66.04-66.04 66.04-66.04a7.5 7.5 0 0 0 0-10.61Z"
    />
  </svg>
);
export default SvgSchlieenAlt;
